export default __webpack_public_path__ + "static/media/Garaz3.765da02c.jpeg";